<template>
<div>
  <div @click="openFile = true">
    <img
        class="document"
        :src="`${publicPath}/icons/black-file-icon.svg`"
    />
  </div>
  <v-dialog :value="openFile" persistent @click:outside="openFile = false" style="align-content: center">
    <v-card style="display: flex; flex-direction: column; min-width: 700px">
      <v-card-title class="text-h5"> RAW Document </v-card-title>
      <v-row style="margin: 15px; overflow: auto; height: 50%">
        <span style="white-space: pre-line">{{ this.document.replace(paper, '').replace(closedPaper, '') }}</span>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="openFile = false"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import constants from "@/util/constants";

export default {
  name: 'ChatAttachedDocumentMessage',
  props: {
    document: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      openFile: false,
      publicPath: constants.isDevelopment ? '' : '',
      paper: '<paper>',
      closedPaper: '</paper>',
    }
  },
  methods: {

  },
};
</script>

<style scoped>
.document {
  height: 40px;
  border-radius: 5px;
}

.document:hover {
  border: solid 2px #00a1fb;
}
</style>
